/* Slim background-buffer progress bar for large datasets.
   Shows while the pipeline streams the remaining pages in the background,
   so users get clear feedback on how much of the full set has loaded. */
export function BufferProgressBar({ loaded = 0, total = 0, active = false }) {
  if (!active || !total || loaded >= total) return null;
  const pct = Math.min(100, Math.max(2, Math.round((loaded / total) * 100)));
  return (
    <div className="w-full mb-2" data-testid="buffer-progress" aria-live="polite">
      <div className="h-1 w-full bg-white/5 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-teal-400 to-emerald-400 transition-[width] duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="mt-1 text-[10px] font-mono text-slate-500 flex items-center gap-1.5">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
        Loading all records… {loaded.toLocaleString()} of {total.toLocaleString()} ({pct}%)
      </div>
    </div>
  );
}

export default BufferProgressBar;
